module.exports = __webpack_public_path__ + "static/media/3_cn.83e06d18.png";